module.exports = __webpack_public_path__ + "img/visa-secure.b0ac6c84.jpg";